import { cn } from '@/lib/utils';

interface ResponsiveContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '7xl' | 'full';
  noPadding?: boolean;
}

const maxWidthClasses = {
  sm: 'max-w-sm',      // 384px
  md: 'max-w-md',      // 448px  
  lg: 'max-w-lg',      // 512px
  xl: 'max-w-xl',      // 576px
  '2xl': 'max-w-2xl',  // 672px
  '7xl': 'max-w-7xl',  // 1280px - Good for main content
  full: 'max-w-full'   // 100%
};

export function ResponsiveContainer({ 
  children, 
  className,
  maxWidth = '7xl',
  noPadding = false
}: ResponsiveContainerProps) {
  return (
    <div className={cn(
      "w-full mx-auto",
      maxWidthClasses[maxWidth],
      !noPadding && "px-6 lg:px-8 xl:px-12",
      className
    )}>
      {children}
    </div>
  );
}